export default "__VITE_ASSET__LRn7J8H0__"